export default __webpack_public_path__ + "static/media/icon-end.9aff1244.svg";